module.exports = __webpack_public_path__ + "img/yellow.1662fb0a.png";